import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mobile-image container"
};
import { onMounted, ref } from "vue";
import ImageMj from "@/views/mobile/pages/ImageMj.vue";
import ImageSd from "@/views/mobile/pages/ImageSd.vue";
import ImageDall from "@/views/mobile/pages/ImageDall.vue";
import { httpGet } from "@/utils/http";
export default {
  __name: 'Image',
  setup(__props) {
    const activeName = ref("");
    const menus = ref([]);
    const activeMenu = ref({
      mj: false,
      sd: false,
      dall: false
    });
    onMounted(() => {
      httpGet("/menu/list").then(res => {
        menus.value = res.data;
        activeMenu.value = {
          mj: menus.value.some(item => item.url === "/mj"),
          sd: menus.value.some(item => item.url === "/sd"),
          dall: menus.value.some(item => item.url === "/dalle")
        };
      });
    });
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_tabs, {
        active: activeName.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => activeName.value = $event),
        class: "my-tab",
        animated: "",
        sticky: ""
      }, {
        default: _withCtx(() => [activeMenu.value.mj ? (_openBlock(), _createBlock(_component_van_tab, {
          key: 0,
          title: "MJ",
          name: "mj"
        }, {
          default: _withCtx(() => [_createVNode(ImageMj)]),
          _: 1
        })) : _createCommentVNode("", true), activeMenu.value.sd ? (_openBlock(), _createBlock(_component_van_tab, {
          key: 1,
          title: "SD",
          name: "sd"
        }, {
          default: _withCtx(() => [_createVNode(ImageSd)]),
          _: 1
        })) : _createCommentVNode("", true), activeMenu.value.dall ? (_openBlock(), _createBlock(_component_van_tab, {
          key: 2,
          title: "DALL",
          name: "dall"
        }, {
          default: _withCtx(() => [_createVNode(ImageDall)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["active"])]);
    };
  }
};